import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: {},
      popTaskShow: false,
      modifyData: {
        "icon": ""
      },
      isLoading: false,
      activity_id: 0,
      selectTab: 0
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/rank/activity/items", {
        activity_id: this.activity_id,
        status: this.selectTab == 0 ? 1 : 0
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data;
      }
    },
    async onCreate() {
      this.modifyData = {
        "activity_id": this.activity_id,
        "sort": "",
        'currency': "GIFTSHARD",
        "status": "1"
      };
      this.popTaskShow = true;
    },
    async onModify(item) {
      this.modifyData = item;
      this.popTaskShow = true;
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onLogs(id) {
      this.$router.push("/luckylotterylogs?item_id=" + id);
    }
  },
  mounted() {
    this.activity_id = this.$route.query.id || 0;
    if (!this.activity_id) {
      this.$router.back();
    }
    this.getData();
  }
};